import { fetchApi } from '@/config/axiosSetting';
import { DeleteSubstitutionPartParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteSubstitutionPart/deleteSubstitutionPartQueryOption.type';

export const deleteSubstitutionPartQueryFunction = (
  params: DeleteSubstitutionPartParamsType,
) => {
  return fetchApi.delete(
    `property/reports/${params?.id}/accident_users/damaged/adjusting/substitution_parts/`,
    {
      params,
    },
  );
};
